<template>
  <div class="dialog_background" @click.self="common.closeDialog()">
    <div class="dialog_container" role="dialog" aria-modal="true">
      <img
        v-if="hasIcon"
        class="alert_logo"
        :src="`/assets/images/common/dialog/alert_${dialog.icon}.png`"
        alt=""
        width="40"
        height="40"
      />

      <div class="title_group" v-if="hasTitle || hasInfo">
        <p class="title" v-if="hasTitle">{{ dialog.title }}</p>
        <p class="info" v-if="hasInfo">{{ dialog.info }}</p>
      </div>

      <div class="subTitle" v-if="hasSubTitle">
        <div class="account_info_box" v-if="isAccountNotice">
          <span
            v-for="(line, index) in subTitleLines"
            :key="index"
            :class="getAccountLineClass(index)"
          >
            {{ line }}
          </span>
        </div>
        <p class="message" v-else>{{ dialog.subTitle }}</p>
      </div>

      <div class="buttonGroup">
        <button
          :class="cancelButton ? 'cancelButton' : 'closeButton'"
          @click="common.closeDialog()"
        >
          {{ cancelButton ? '취소' : '닫기' }}
        </button>
        <button
          v-if="cancelButton"
          class="addButton"
          :class="dialog.button.color"
          @click="confirm"
        >
          {{ dialog.button.content }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    onKeydown(event) {
      if (event.key === 'Escape') this.common.closeDialog();
    },
    confirm() {
      this.common.dialog.button.onClick();
      this.common.closeDialog();
    },
    getAccountLineClass(index) {
      // 계좌번호 안내 문구는 줄마다 다른 스타일을 적용한다
      const classes = ['bank_name', 'account_number', 'account_holder', 'empty_line', 'instruction'];
      return classes[index] || '';
    }
  },
  computed: {
    dialog() {
      return this.common.dialog;
    },
    hasIcon() {
      return this.dialog.icon !== null && this.dialog.icon !== undefined;
    },
    hasTitle() {
      return this.dialog.title !== null && this.dialog.title !== undefined;
    },
    hasInfo() {
      return this.dialog.info !== null && this.dialog.info !== undefined;
    },
    hasSubTitle() {
      return this.dialog.subTitle !== null && this.dialog.subTitle !== undefined;
    },
    subTitleLines() {
      return this.hasSubTitle ? this.dialog.subTitle.split('\n') : [];
    },
    // 계좌 안내 형식일 때만 별도 박스로 감싼다 (일반 메시지는 평문으로 노출)
    isAccountNotice() {
      return this.subTitleLines.length > 0 && this.subTitleLines[0].includes('KB국민');
    },
    cancelButton() {
      return this.dialog.button !== null && this.dialog.button !== undefined;
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/style/common/dialog.scss';
</style>
